import React,{useEffect,useRef} from 'react';
import { useDispatch } from 'react-redux';
import BasePage from '../common/base';
import { PackSetsContainer } from './pack-sets.container';
import { Container } from '@material-ui/core';
import { DashboardStyles } from '../../hooks/styles';
import {Constants} from "../../constants/Constants";
const PackSets = () => {
  const classes = DashboardStyles();
  const isFirstRender = useRef(true)
  const dispatch = useDispatch();
  useEffect(() => {
    isFirstRender.current = false
  }, [dispatch])

  return (
    <BasePage title={Constants.PAGE_TITLE.PACK_SETS}>
      <div className={classes.appBarSpacer}></div>
      <Container maxWidth={false} className={classes.container}>
        <PackSetsContainer />
      </Container>
    </BasePage>
  )
}

export default PackSets;